import { useEffect, useState, useContext } from "react";
import { DEALER_LOGIN_URL } from "../../Essentials/variables";
import { AppContext } from "../../Context";
import "./DealerMSPIN.css";
import _ from "lodash";
import axios from "axios";
import { sendOTP, verifyOTP } from "../../store/apis/dealerAuthApi";
function DealerMSPIN(props) {
  const [otp, setOtp] = useState();
  const [mspinok, setMspinok] = useState(0);
  const [passwod, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [requestButton, setrequestButton] = useState(0);

  const handleSendMSPIN = (e) => {
    e.preventDefault();
    //remove//
    axios({
      method: "GET",
      withCredentials: false,
      url: DEALER_LOGIN_URL + `/${otp}`,
    }).then((res) => {
      // console.log("parent name ",res.data?.type);
      // setDealersData(res.data?.type); //data: "Success Autheticated"
      if (res.data?.message === "Success") {
        // console.log("Saving....");
        localStorage.setItem("token", JSON.stringify(res.data["token"]));
        localStorage.setItem(
          "userInfo",
          JSON.stringify(_.omit(res.data, ["token"]))
        );
        // if(otp==='667736'){
        //   props.nav("/access");
        // }
        // props.nav("/access");
        ///Uncomment to send OTP
        sendOTP(otp).then((res) => {
          console.log(res);
          if (res === "OTP sent successfully on MyApp") {
            setMessage(res);
           setMspinok(1);
          } else {
            console.log("send otp response", res );
          }
        });
          // props.nav('/dealeradmin') //
      } 
      else if (res.data?.message === "Not Registered") {
        setMessage("Ask for access");
        setMspinok(0);
        setrequestButton(1);
      } else if (res.data?.message === "user status is pending") {
        setMessage("Access awaited by admin");
      } else {
        // setuser(res.data);
        // console.log(res.data);
        setMessage("Wrong MSPIN");
      }
      // console.log(res.data.Access);
    });
    //remove/
    if(requestButton!==1) {
    // loginClient.sendOtp(otp).then((res) => {
    //   console.log(res);
    //   if (res.status === "OTP_SENT_SUCCESS") {
    //     setMessage("OTP sent sucsessfully");
    //    setMspinok(1);
    //   }
    // });
  }
  };
  const handleSendOTP = (e) => {
    const Token = localStorage.getItem("token");
    e.preventDefault();
    verifyOTP(otp,passwod).then((res) => {
      console.log(res);
      console.log('res from verifyOTP', res);
      if (res === "OTP_VERIFIED") {
        setMessage("Success Login");

        axios({
          method: "GET",
          headers: {
            "x-access-token": Token,
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Frame-Options": "DENY",
            "Content-Security-Policy": "frame-ancestors 'none'",
            "Feature-Policy": "frame-ancestors 'none'",
          },
          withCredentials: false,
          url: DEALER_LOGIN_URL + `/${otp}`
        })
        .then((res) => {
          console.log('handling otp', res.data); //data: "Success Autheticated"
          if (res.data?.message === "Success") {
            // console.log("Saving....");
            localStorage.setItem("token", JSON.stringify(res.data["token"]));
            localStorage.setItem(
              "userInfo",
              JSON.stringify(_.omit(res.data, ["token"]))
            );
            props.nav("/access");
            //   props.nav('/dealeradmin') //
          } else if (res.data?.message === "Not Registered") {
            setMessage("Ask for access");
            setMspinok(0);
            setrequestButton(1);
          } else if (res.data?.message === "user status is pending") {
            setMessage("Access awaited by admin");
          } else {
            // setuser(res.data);
            // console.log(res.data);
            setMessage("Wrong MSPIN");
          }
        })
        .catch((error) => {
          console.error("Error in API call:", error);
          // Handle the error here, such as displaying an error message to the user
        });
        console.log("Success");
      } else {
        setMessage(res);
      }
    })
    .catch((error) => {
      console.error("Error in OTP verification:", error);
      setMessage(error.errorMessage);
      // Handle the OTP verification error here
    });
  };
  const handleSignupButton = () => {
    axios({
      method: "POST",
      data: {
        type: "dealer",
        mspin: `/${otp}`,
      },
      withCredentials: false,
      url: DEALER_LOGIN_URL + `/${otp}`,
    }).then((res) => {
      console.log(res.data);
      setrequestButton(0);
      //data: "Success Autheticated"
      if (res.data?.message === "success") {
        setMessage("Request sent successfully");
      }
      if (res.data?.message === "No user found for this MSPIN") {
        setMessage("No user found with the given MSPIN");
      }
    });
  };

  return (
    <div>
      <section
        style={{
          backgroundImage: " url(bg1.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "100vh",
        }}
      >
        <div className="absolute inset-y-0 left-0 w-1/2 flex items-center justify-center pointer-events-none">
          <div className="flex flex-col items-end w-[65%] max-w-[420px]">
            <img
              src="marutilogo.png"
              className="w-full h-auto max-h-[84px] object-contain"
              alt="Maruti Suzuki Logo"
            />
            <img
              src="ruralmaps.png"
              className="w-[70%] h-auto mt-2 object-contain"
              alt="Rural Maps"
            />
          </div>
        </div>
        {/* ////Show mspin enter form */}
        {mspinok === 0 && (
          <form onSubmit={handleSendMSPIN}>
            <div className="">
              <div className="ml-auto w-1/2 main-dealer-login-container">
                {/* <div className="absolute "> */}
                <div className="login-as-dealer-heading ">
                  <p className="font-roboto italic font-normal leading-7 text-center text-lg">
                    {" "}
                    Login As Dealer{" "}
                  </p>
                </div>
                {/* <div className="absolute px-16 py-52"> */}
                <div className="mspinInput-div">
                  <input
                    type="number"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    placeholder="Enter MSPIN"
                    className="font-roboto font-normal mspinInput"
                    required=""
                  />
                </div>
                <div className="dealer-btns">
                  {/* <div className="absolute px-12 transform bottom-72 "> */}
                  <div className=" ">
                    <button
                      type="submit"
                      // className="bg-gradient-to-r from-blue-400 to-blue-700 text-white px-5 py-2 "
                      className="bg-gradient-to-r from-blue-400 to-blue-700 text-white sign-in-btn"
                    >
                      Sign In
                    </button>
                  </div>
                  <div className="request-btns">
                    {<p className="text-slate-300">{message}</p>}

                    {requestButton===1 && 
                      // <div className=" dealer-login-btns px-56 pt-20">
                      <div className=" request-login-btns">
                        <button
                          onClick={handleSignupButton}
                          type="button"
                          className="text-white bg-gradient-to-br from-purple-600
                         to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none
                          focus:ring-blue-300 dark:focus:ring-blue-800 font-medium request-access-btn"
                        >
                          Request Access
                        </button>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </form>
        )}
        {/* /////show otp sending form */}
        {mspinok === 1 && (
          <form onSubmit={handleSendOTP}>
            <div className="">
              <div className="ml-auto w-1/2 main-dealer-login-container ">
                <div className="login-as-dealer-heading">
                  <p className="font-roboto italic font-normal leading-7 text-center text-lg">
                    Enter OTP
                  </p>
                </div>
                <div className="mspinInput-div">
                  <input
                    type="password"
                    value={passwod}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter OTP"
                    className="font-roboto font-normal focus:outline-none mspinInput"
                    required=""
                  />
                </div>
                <div className="dealer-btns ">
                  <button
                    type="submit"
                    className="bg-gradient-to-r from-blue-400 to-blue-700 text-white sign-in-btn "
                  >
                    Sign In
                  </button>
                </div>
                <div className="request-btns">
                <p className="text-red-500 font-bold py-1 px-4 rounded">{message}</p>
                </div>
              </div>
            </div>
          </form>
        )}

        {/* {<p className="text-slate-300">{message}</p>}
      {requestButton && (
        <div className="px-56 pt-20">
          <button
            onClick={handleSignupButton}
            type="button"
            className="text-white bg-gradient-to-br from-purple-600
             to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none
              focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg 
              text-sm px-10 py-3 text-center mr-2 mb-2"
          >
            Request Access
          </button>
        </div>
      )} */}
      </section>
    </div>
  );
}
export default DealerMSPIN;
